(() => {
  const form = document.getElementById('contactCustomForm');
  if (!form) return;

  const endpoint = 'https://contact-form-arachne.gadget.app/contact-form';

  const filesInput = document.getElementById('cc-files');
  const dropzone = document.getElementById('cc-dropzone');
  const submitBtn = document.getElementById('cc-submit');
  const statusEl = document.getElementById('cc-status');
  const purchaseDateInput = document.getElementById('cc-purchaseDate');
  const filesSummary = document.getElementById('cc-files-summary');
  const previewURLs = new Set();

  function clearFilesSummary() {
    if (!filesSummary) return;
    previewURLs.forEach((url) => URL.revokeObjectURL(url));
    previewURLs.clear();
    filesSummary.innerHTML = '';
  }

  // Placeholder-first date input: start as text to show placeholder and no icon,
  // temporarily switch to native date on focus/click, then revert if empty.
  if (purchaseDateInput) {
    const toDateAndOpen = () => {
      try {
        purchaseDateInput.type = 'date';
        purchaseDateInput.showPicker && purchaseDateInput.showPicker();
      } catch (_) {}
    };
    purchaseDateInput.addEventListener('focus', toDateAndOpen);
    purchaseDateInput.addEventListener('click', toDateAndOpen);
    purchaseDateInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toDateAndOpen();
      }
    });
    purchaseDateInput.addEventListener('blur', () => {
      if (!purchaseDateInput.value) purchaseDateInput.type = 'text';
    });
    form.addEventListener('reset', () => {
      // Allow the reset to clear the value first
      setTimeout(() => {
        if (!purchaseDateInput.value) purchaseDateInput.type = 'text';
      }, 0);
    });
  }

  function setStatus(message, isError = false) {
    statusEl.textContent = message || '';
    statusEl.style.color = isError ? '#b00020' : 'inherit';
  }

  // Inline field error helpers
  const fieldIds = [
    'cc-fullName',
    'cc-email',
    'cc-phone',
    'cc-orderNumber',
    'cc-purchaseDate',
    'cc-subject',
    'cc-message',
    'cc-files'
  ];

  function setFieldError(fieldId, message) {
    const inputEl = document.getElementById(fieldId);
    const errEl = document.getElementById(fieldId + '-error');
    if (!errEl) return;
    errEl.textContent = message || '';
    const fieldWrap = inputEl ? inputEl.closest('.field') : errEl.closest('.field');
    if (message) {
      fieldWrap && fieldWrap.classList.add('has-error');
      if (inputEl) {
        inputEl.setAttribute('aria-invalid', 'true');
        inputEl.setAttribute('aria-describedby', fieldId + '-error');
      }
    } else {
      fieldWrap && fieldWrap.classList.remove('has-error');
      if (inputEl) {
        inputEl.removeAttribute('aria-invalid');
        // Only remove aria-describedby if it points to our error id
        const describedBy = inputEl.getAttribute('aria-describedby');
        if (describedBy === fieldId + '-error') inputEl.removeAttribute('aria-describedby');
      }
    }
  }

  function clearAllErrors() {
    fieldIds.forEach((id) => setFieldError(id, ''));
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function validPhone(v) {
    if (!v) return false;
    const cleaned = v.replace(/[^+\d]/g, '');
    return /^\+?\d{7,15}$/.test(cleaned);
  }

  // Clear/validate per-field on input/blur
  function onInputValidate(id, getErrorMessage) {
    const el = document.getElementById(id);
    if (!el) return;
    const handler = () => {
      const value = (el.value || '').toString().trim();
      const msg = getErrorMessage ? getErrorMessage(value) : '';
      setFieldError(id, msg);
    };
    el.addEventListener('input', handler);
    el.addEventListener('blur', handler);
  }

  onInputValidate('cc-fullName', (v) => (v ? '' : 'Full name is required'));
  onInputValidate('cc-email', (v) => (!v ? 'Email is required' : !validEmail(v) ? 'Enter a valid email address' : ''));
  onInputValidate('cc-phone', (v) => (!v ? 'Phone number is required' : !validPhone(v) ? 'Enter a valid phone number' : ''));
  onInputValidate('cc-subject', (v) => (v ? '' : 'Subject is required'));
  onInputValidate('cc-message', (v) => (v ? '' : 'Message is required'));

  // UI: show selected files summary with image thumbnails under the dropzone
  function updateFilesSummary() {
    if (!filesInput || !filesSummary) return;
    const files = filesInput.files ? Array.from(filesInput.files) : [];

    // Clear previous thumbnails and revoke URLs
    clearFilesSummary();

    if (!files.length) {
      if (dropzone) dropzone.classList.remove('has-files');
      return;
    }

    // Header with files count
    const header = document.createElement('div');
    header.className = 'cc-files-count';
    header.textContent = `${files.length} ${files.length === 1 ? 'file' : 'files'} selected`;
    filesSummary.appendChild(header);

    // Thumbnails list
    const list = document.createElement('ul');
    list.className = 'cc-files-list';

    files.forEach((file) => {
      const li = document.createElement('li');
      li.className = 'cc-file';

      const thumbWrap = document.createElement('div');
      thumbWrap.className = 'cc-thumb';

      const img = document.createElement('img');
      img.alt = file.name;
      img.loading = 'lazy';
      const url = URL.createObjectURL(file);
      previewURLs.add(url);
      img.src = url;
      thumbWrap.appendChild(img);

      const caption = document.createElement('div');
      caption.className = 'cc-file-name';
      caption.textContent = file.name;

      li.appendChild(thumbWrap);
      li.appendChild(caption);
      list.appendChild(li);
    });

    filesSummary.appendChild(list);

    if (dropzone) {
      if (files.length) dropzone.classList.add('has-files');
      else dropzone.classList.remove('has-files');
    }
  }

  function acceptImagesOnly(files) {
    return Array.from(files).filter((f) => /^image\//.test(f.type));
  }

  // Open file dialog from the dropzone by click/keyboard
  dropzone?.addEventListener('click', () => filesInput.click());
  dropzone?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      filesInput.click();
    }
  });

  // Drag & drop support for the dropzone
  dropzone?.addEventListener('dragenter', (e) => {
    e.preventDefault();
    dropzone.classList.add('dragover');
  });
  dropzone?.addEventListener('dragover', (e) => {
    e.preventDefault();
    dropzone.classList.add('dragover');
  });
  dropzone?.addEventListener('dragleave', () => {
    dropzone.classList.remove('dragover');
  });
  dropzone?.addEventListener('drop', (e) => {
    e.preventDefault();
    dropzone.classList.remove('dragover');

    const dtFiles = e.dataTransfer?.files || [];
    const originalCount = dtFiles.length;
    const acceptedImages = acceptImagesOnly(dtFiles);
    const limited = acceptedImages.slice(0, 5);

    const dt = new DataTransfer();
    limited.forEach((f) => dt.items.add(f));
    filesInput.files = dt.files;

    // Pass original count to change handler so it can set error correctly
    filesInput.dataset.dropOriginalCount = String(originalCount);

    // Trigger change so any other listeners can react and for summary rendering
    filesInput.dispatchEvent(new Event('change'));
  });

  // Clear all inline errors and UI on form reset
  form.addEventListener('reset', () => {
    setTimeout(() => {
      clearAllErrors();
      clearFilesSummary();
      if (dropzone) {
        dropzone.classList.remove('dragover');
        dropzone.classList.remove('has-files');
      }
    }, 0);
  });

  filesInput.addEventListener('change', () => {
    // If coming from drop, use the originally dropped count to determine errors
    const droppedOriginalCount = filesInput.dataset.dropOriginalCount ? parseInt(filesInput.dataset.dropOriginalCount, 10) : null;

    // Prepare accepted & limited list from current selection
    const originalCount = droppedOriginalCount ?? (filesInput.files ? filesInput.files.length : 0);
    const acceptedImages = acceptImagesOnly(filesInput.files || []);
    const limited = acceptedImages.slice(0, 5);

    // Build a new FileList with accepted & limited files (idempotent)
    const dt = new DataTransfer();
    limited.forEach((f) => dt.items.add(f));
    filesInput.files = dt.files;

    // Determine if we rejected any (non-image) or truncated (>5)
    const rejectedOrTruncated = originalCount !== limited.length;
    if (rejectedOrTruncated) {
      setFieldError('cc-files', 'Only image files are allowed. Maximum 5 files.');
    } else {
      setFieldError('cc-files', '');
    }

    // Render summary
    updateFilesSummary();

    // Clear flag after handling a drop-originated change
    if (filesInput.dataset.dropOriginalCount) delete filesInput.dataset.dropOriginalCount;
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearAllErrors();
    setStatus('');

    const data = new FormData(form);

    const fullName = (data.get('fullName') || '').toString().trim();
    const email = (data.get('email') || '').toString().trim();
    const phone = (data.get('phone') || '').toString().trim();
    const orderNumber = (data.get('orderNumber') || '').toString().trim();
    const purchaseDate = (data.get('purchaseDate') || '').toString().trim();
    const subject = (data.get('subject') || '').toString().trim();
    const message = (data.get('message') || '').toString().trim();

    let hasError = false;
    let firstInvalidId = null;

    function markError(id, msg) {
      setFieldError(id, msg);
      if (!hasError) {
        hasError = true;
        firstInvalidId = id;
      }
    }

    // Validate fields
    if (!fullName) markError('cc-fullName', 'Full name is required');

    if (!email) {
      markError('cc-email', 'Email is required');
    } else if (!validEmail(email)) {
      markError('cc-email', 'Enter a valid email address');
    }

    if (!phone) {
      markError('cc-phone', 'Phone number is required');
    } else if (!validPhone(phone)) {
      markError('cc-phone', 'Enter a valid phone number');
    }
    if (!subject) markError('cc-subject', 'Subject is required');
    if (!message) markError('cc-message', 'Message is required');

    // Files validation: images only, max 5
    const files = acceptImagesOnly(filesInput.files || []).slice(0, 5);
    if ((filesInput.files ? filesInput.files.length : 0) !== files.length) {
      markError('cc-files', 'Only image files are allowed. Maximum 5 files.');
    } else {
      setFieldError('cc-files', '');
    }

    if (hasError) {
      // Focus the first invalid control (for files, focus the dropzone)
      const firstEl = firstInvalidId === 'cc-files' ? document.getElementById('cc-dropzone') : document.getElementById(firstInvalidId);
      firstEl && firstEl.focus && firstEl.focus();
      return;
    }

    // Build request FormData exactly as required
    const formdata = new FormData();
    files.forEach((file) => formdata.append('files', file, file.name));
    formdata.append('fullName', fullName);
    formdata.append('email', email);
    formdata.append('phone', phone);
    if (orderNumber) formdata.append('orderNumber', orderNumber);
    if (purchaseDate) formdata.append('purchaseDate', purchaseDate);
    formdata.append('subject', subject);
    formdata.append('message', message);

    const requestOptions = { method: 'POST', body: formdata, redirect: 'follow' };

    try {
      submitBtn.disabled = true;
      setStatus('Sending...');
      const resp = await fetch(endpoint, requestOptions);
      const text = await resp.text();
      if (!resp.ok) throw new Error(text || 'Request failed');
      setStatus('Thank you! Your message has been sent.');
      form.reset();
      // Clear summary explicitly after reset
      if (filesSummary) filesSummary.textContent = '';
    } catch (error) {
      console.error(error);
      setStatus('Sorry, something went wrong. Please try again later.', true);
    } finally {
      submitBtn.disabled = false;
    }
  });
})();
